var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layout-seat",
      class: {
        disabled: _vm.disabledSeatClass,
        "elevation-6": _vm.elevateSeat,
        "reposition-seat": _vm.repositionBooking,
        "reposition-hint": _vm.repositionHint,
        "happy-seat": _vm.mySeat.managerReserved
      },
      style: {
        top: _vm.top,
        left: _vm.left,
        height: _vm.seatHeight,
        width: _vm.seatWidth,
        border: "solid 2px " + _vm.seatBorderColor,
        background: _vm.seatBG,
        "border-style": _vm.borderStyle
      },
      attrs: { "data-seat_id": _vm.mySeat.id },
      on: {
        contextmenu: function($event) {
          _vm.showContextMenu($event)
        },
        click: [
          function($event) {
            _vm.seatClicked($event)
          },
          function($event) {
            if (!$event.ctrlKey) {
              return null
            }
            _vm.seatAddedToSelection($event)
          }
        ],
        mousedown: function($event) {
          _vm.triggerEnableEditMode("mouse-click")
        },
        touchstart: function($event) {
          _vm.triggerEnableEditMode("screen-touch")
        }
      }
    },
    [
      _c(
        "p",
        {
          staticClass: "layout-seat-name subheading text-xs-center",
          style: { "margin-top": _vm.titleMarginTop },
          attrs: { slot: "activator" },
          slot: "activator"
        },
        [
          _vm.scoreView
            ? [
                _c(
                  "span",
                  { staticClass: "caption", style: { color: _vm.textColor } },
                  [_vm._v(_vm._s(_vm.mySeat.slotScore))]
                )
              ]
            : [
                _vm.showSeatText
                  ? _c(
                      "span",
                      {
                        staticClass: "caption",
                        style: { color: _vm.textColor }
                      },
                      [_vm._v(_vm._s(_vm.seatInnerTitle))]
                    )
                  : _c("v-icon", { attrs: { color: _vm.iconColor } }, [
                      _vm._v(_vm._s(_vm.seatInnerTitle))
                    ])
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26fef9ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26fef9ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Seat.vue
// module id = null
// module chunks = 